'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _SelectOptions = require('./SelectOptions.scss');

var _SelectOptions2 = _interopRequireDefault(_SelectOptions);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _constants = require('../../shared/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class() {
        var _temp, _this, _ret;

        _classCallCheck(this, _class);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
            marked: -1
        }, _this._getContent = function () {
            var marked = _this.state.marked;
            var _this$props = _this.props,
                options = _this$props.options,
                uniqueId = _this$props.uniqueId;


            return _lodash2.default.map(options, function (option, index) {
                var name = option.name,
                    value = option.value,
                    disabled = option.disabled,
                    type = option.type;

                var optionName = _this._getOptionName(name, type);
                var isMarked = marked === index;

                return _react2.default.createElement(
                    'div',
                    { key: index,
                        role: 'option',
                        tabIndex: 0,
                        'aria-setsize': options.length,
                        'aria-posinset': index,
                        'aria-selected': isMarked,
                        'aria-label': name,
                        id: 'site-react-dropdown_' + uniqueId + '_' + index,
                        onFocus: function onFocus(e) {
                            return _this._onFocus(e, index);
                        },
                        className: _SelectOptions2.default.wixDropdownPanelItem + ' ' + _constants.CLASSES.SELECT_OPTION + ' ' + (disabled ? _SelectOptions2.default.disabled : '') + ' ' + (isMarked ? _constants.CLASSES.SELECT_OPTION_MARKED : ''),
                        onClick: function onClick(e) {
                            return _this._onSelect(e, value, disabled);
                        },
                        onMouseEnter: function onMouseEnter() {
                            return _this._onMouseEnter(index);
                        } },
                    optionName
                );
            });
        }, _this._onMouseEnter = function (index) {
            _this.setState({ marked: index });
        }, _this._onMouseLeave = function () {
            _this.setState({ marked: -1 });
        }, _this._onSelect = function (e, value, disabled) {
            var onSelect = _this.props.onSelect;


            if (!disabled && onSelect) {
                onSelect({ value: value });
            }

            if (e) {
                e.preventDefault();
            }

            return false;
        }, _this._onFocus = function (e, index) {
            var marked = _this.state.marked;


            if (marked !== index) {
                _this.setState({ marked: index });

                e.preventDefault();
                e.stopPropagation();
            }
        }, _this._onKeyDown = function (e) {
            var options = _this.props.options;

            var key = e.keyCode || e.which;
            var captured = false;

            switch (key) {
                case _constants.KEY_CODES.UP:
                    _this._markUp();
                    captured = true;
                    break;
                case _constants.KEY_CODES.DOWN:
                    _this._markDown();
                    captured = true;
                    break;
                case _constants.KEY_CODES.HOME:
                    _this._move(0);
                    captured = true;
                    break;
                case _constants.KEY_CODES.END:
                    _this._move(options.length - 1);
                    captured = true;
                    break;
                case _constants.KEY_CODES.ENTER:
                case _constants.KEY_CODES.TAB:
                    _this._onEnter(e);
                    captured = true;
                    break;
            }

            if (captured) {
                e.preventDefault();
            }

            return !captured;
        }, _this._markDown = function () {
            var marked = _this.state.marked;
            var options = _this.props.options;


            if (marked < options.length - 1) {
                _this._move(marked + 1);
            }
        }, _this._markUp = function () {
            var marked = _this.state.marked;


            if (marked > -1) {
                _this._move(marked - 1);
            }
        }, _this._move = function (newPosition) {
            var options = _this.props.options;

            var marked = Math.max(Math.min(newPosition, options.length), 0);
            _this.setState({ marked: marked }, function () {
                return _this._fixScrollIfNeeded(newPosition);
            });
        }, _this._fixScrollIfNeeded = function (newPosition) {
            var wrappingElem = $(_this.listElem);
            var child = wrappingElem.find(':nth-child(' + (newPosition + 1) + ')');
            var scrollTop = 0;

            if (child && child.length === 1) {
                var topPosition = child.position().top - 1;
                var scrollPosition = wrappingElem.scrollTop();
                var maxHeight = wrappingElem.outerHeight() - 2;
                var diff = topPosition + _constants.LIST_ITEM_HEIGHT - maxHeight;

                if (diff > 0) {
                    scrollTop = scrollPosition + diff;
                } else if (topPosition < 0) {
                    scrollTop = scrollPosition + topPosition;
                } else {
                    scrollTop = scrollPosition;
                }
            }

            wrappingElem.scrollTop(scrollTop);
        }, _this._onEnter = function (e) {
            var marked = _this.state.marked;
            var options = _this.props.options;

            var value = null;

            if (marked > -1 && marked < options.length) {
                value = options[marked].value;
            }

            _this._onSelect(e, value);
        }, _this._focusOption = function () {
            var marked = _this.state.marked;


            if (marked > -1 && _this.listElem && _this.listElem.children && _this.listElem.children.length) {
                _this.listElem.children[marked].focus();
            }
        }, _this._getOptionName = function (name, type) {
            var optionName = name;

            if (type) {
                switch (type) {
                    case 'time':
                        optionName = _react2.default.createElement(
                            'time',
                            null,
                            optionName
                        );
                        break;
                }
            }

            return optionName;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _class.prototype.componentDidMount = function componentDidMount() {
        $(document).on('keydown', this._onKeyDown);
        this.setState({ marked: 0 });
    };

    _class.prototype.componentWillUnmount = function componentWillUnmount() {
        $(document).off('keydown', this._onKeyDown);
    };

    _class.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        var marked = this.state.marked;


        if (marked !== prevState.marked) {
            this._focusOption();
        }
    };

    _class.prototype.render = function render() {
        var _this2 = this;

        var marked = this.state.marked;
        var _props = this.props,
            className = _props.className,
            rtl = _props.rtl,
            uniqueId = _props.uniqueId;

        var content = this._getContent();
        className = (className || '') + ' ' + _SelectOptions2.default.wixDropdownPanelContainer + ' ' + (rtl ? _SelectOptions2.default.rtl : '');

        return _react2.default.createElement(
            'div',
            { ref: function ref(e) {
                    return _this2.listElem = e;
                },
                className: className,
                onMouseLeave: this._onMouseLeave,
                role: 'listbox',
                'aria-expanded': 'true',
                'aria-activedescendant': 'site-react-dropdown_' + uniqueId + '_' + marked,
                id: 'site-react-dropdown-panel_' + uniqueId },
            content
        );
    };

    return _class;
}(_react2.default.Component);

_class.defaultProps = {
    options: [],
    onSelect: function onSelect() {},
    className: '',
    rtl: false
};
exports.default = _class;